module.exports = __webpack_public_path__ + "static/ofcar9-77607ecce8f58fc6337eb2675ad63eb8.jpg";